import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { BiTrackApi } from './apis/bi-track-api';
import { BiTrackApiImpl } from './apis/impls/bi-track-api';
import { BiTrackRepositoryImpl } from './repositories/impls/bi-track-repository';
import { BiTrackRepository } from './services/bi-track-repository';
import { BiTrackServiceImpl } from './services/impls/bi-track-service';
import { BiTrackService } from './services/bi-track-service';

export const biTrackModule = new ContainerModule((bind) => {
  bind(BiTrackApi).to(BiTrackApiImpl);
  bind(BiTrackRepository).to(BiTrackRepositoryImpl);
  bind(BiTrackService).to(BiTrackServiceImpl);
});
